import i18n from 'i18n/config';

export const requiredErrorMessage = i18n.t('Dies ist ein Pflichtfeld');
